


export function UserProfileSection({ headline, children }: React.PropsWithChildren<{ headline: string }>) {
    return (
        <div className="mt-8">
            <h3 className="text-md font-semibold text-onbackground mb-4">
                {headline}
            </h3>
            {/* User profile content */}

            {children}
        </div>
    );
}
